import { apiGetCompanyByCode } from "services/CompanyService";
import { MOLE_COMPANY_CODE } from "constants/moduleConstants/contract.constant";
import getContractCompanyCode from "utils/getContractCompanyCode";

/**
 * Mol-e sözleşmeleri her domainde gerekir.
 * platform/app/proje dışındaki whitelabel domainlerde ek şirket id'si döner.
 */
const resolveContractCompanyScope = async () => {
  const domainCode = getContractCompanyCode();
  const moleResponse = await apiGetCompanyByCode(MOLE_COMPANY_CODE);
  const moleCompanyId = moleResponse?.data?.data?.id ?? null;

  let supplementalCompanyId = null;
  if (domainCode !== MOLE_COMPANY_CODE) {
    const supplementalResponse = await apiGetCompanyByCode(domainCode);
    supplementalCompanyId = supplementalResponse?.data?.data?.id ?? null;
  }

  return {
    domainCode,
    moleCompanyId,
    supplementalCompanyId,
  };
};

export default resolveContractCompanyScope;
